import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TabCfop } from '../interfaces/tab-cfop';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

/**
 * CFOP (ef_tabcfop, schema padrao). Consulta liberada aos perfis de faturamento;
 * gravar/excluir exige ROLE_ROOT — a API rejeita os demais com 403.
 */
@Injectable({
  providedIn: 'root'
})
export class TabCfopService {

  readonly path = '/cfop';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(cfop: TabCfop): Observable<TabCfop> {
    return this.http.put<TabCfop>(`${this.jwtAuthService.apiUrl + this.path}`, cfop);
  }

  getCfop(id: string): Observable<TabCfop> {
    return this.http.get<TabCfop>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  /** CFOPs habilitados, para combos. */
  getAtivos(): Observable<TabCfop[]> {
    return this.http.get<TabCfop[]>(`${this.jwtAuthService.apiUrl + this.path}/lista/ativos`);
  }

  getCfopPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<TabCfop>> {
    return this.http.get<PageResult<TabCfop>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
      + `${size}&order=${order}&direction=${direction}`);
  }

  getCfopPageSearch(page?: number, size?: number, search?: string,
    order?: string, direction?: string): Observable<PageResult<TabCfop>> {
    return this.http.get<PageResult<TabCfop>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
      `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}
